<template>
  <div class="digital-hyper-link">
    <el-dialog
      title="上接下转稿件"
      width="380px"
      top="calc( 50vh - 60px )"
      class="hyper-link__dialog"
      center
      :visible.sync="visible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <ul class="title-wrapper">
        <li v-for="item in bookCatalogList" :key="item.id">
          <div v-for="title in item.children" :key="title.id" :class="{ active: title.xiaoYangId == selectedId }" class="title-detail" @click="selectedTitle(title)">
            <span>
              {{ title.label | label }}
            </span>
          </div>
        </li>
      </ul>
      <div class="dialog-footer" slot="footer">
        <span class="" @click="handleCancel()">取消</span>
        <span class="confirm" @click="confirm()">确定</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import getBook from '@api/getBook'

export default {
  name: 'DigitalHyperLink',
  data() {
    return {
      visible: false,
      articleText: '',
      selectedId: ''
    }
  },
  computed: {
    bookCatalogList() {
      return this.$store.state.book.bookCatalogList
    }
  },
  filters: {
    label(value) {
      if (value) {
        return value.trim() ? value : '未命名稿件'
      } else {
        return '未命名稿件'
      }
    }
  },
  methods: {
    handleCancel() {
      this.visible = false
    },
    confirm() {
      this.$emit('get-dayang-Id', this.selectedId)
      this.$emit('setSectionToParagraphLink')
      sessionStorage.setItem('hyperLinkId', this.selectedId)
      this.handleCancel()
      console.log(this.selectedId, 'this.selectedIdthis.selectedIdthis.selectedId')
    },
    selectedTitle(row) {
      this.selectedId = row.xiaoYangId
    }
  }
}
</script>

<style scoped lang="scss">
.title-wrapper {
  margin-bottom: 20px;
  li {
  }
  .title-detail:hover {
    background: rgba(249, 232, 223, 1);
  }
  .title-detail {
    padding: 5px 25px;
    margin-bottom: 10px;
    //padding: 3px ;
    color: #000;
    font-size: 16px;
    cursor: pointer;
    span {
      display: inline-block;
      width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .active {
    background: rgba(249, 232, 223, 1);
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
  span {
    //display: inline-block;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: rgba(227, 227, 227, 1);
    cursor: pointer;
    font-size: 16px;
  }
  .confirm {
    background: rgba(222, 87, 16, 1);
    color: #fff;
  }
}
</style>
<style lang="scss">
.hyper-link__dialog {
  .el-dialog {
    margin-right: 0;
  }
  .el-dialog__body {
    max-height: 300px;
    overflow-y: scroll;
    padding: 25px 0 !important;
  }
}
</style>
